
const muiTypography = {
  styleOverrides: {
    noWrap(styles) {
        return {
            whiteSpace: "initial",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: String(styles.ownerState['data-lines'] || '2'),
            WebkitBoxOrient: "vertical",
        }
    }
  },
};

export default muiTypography;
